/* unplugin-vue-components disabled */import { render } from "./chat-input.vue?vue&type=template&id=2fdb3eef&scoped=true"
import script from "./chat-input.vue?vue&type=script&lang=js"
export * from "./chat-input.vue?vue&type=script&lang=js"

import "./chat-input.vue?vue&type=style&index=0&id=2fdb3eef&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdb3eef"],['__file',"src/components/chat-input/chat-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fdb3eef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fdb3eef', __exports__)) {
    api.reload('2fdb3eef', __exports__)
  }
  
  module.hot.accept("./chat-input.vue?vue&type=template&id=2fdb3eef&scoped=true", () => {
    api.rerender('2fdb3eef', render)
  })

}


export default __exports__